import React from 'react';
import ReactModal from 'react-modal';
import './modal.scss';

class Modal extends React.Component {
  render() {
    const { isOpen, closeModal, className, child, ariaProps } = this.props;
    return (
      <ReactModal
        isOpen={isOpen}
        overlayClassName="modal-overlay"
        className={className}
        onRequestClose={closeModal}
        id="modal"
        aria={ariaProps}
      >
        {child}
      </ReactModal>
    );
  }
}
ReactModal.setAppElement('#root');
export default Modal;
